<template>
  <div>

    <div class="bg-gray-600 gray-300 ">
      <div class="container p-4">
        <el-row :gutter="24">
          <el-col :sapn="5" :lg="5">
            <h6>公司产品</h6>
            <span class="blockquote-footer2 pb-2" v-for="(item,index) in productList" @click="navNewsClick(item)">{{item.title}}</span>
          </el-col>
          <el-col :sapn="5" :lg="5">
            <h6>解决方案</h6>
            <!--<span class="blockquote-footer2 pb-2">智慧监狱</span>-->
            <span class="blockquote-footer2 pb-2" @click="navClick('7','11','256')">智慧校园</span>
            <!--<span class="blockquote-footer2 pb-2">智慧院所</span>-->
            <span class="blockquote-footer2 pb-2" @click="navClick('7','10','127')">智慧农业</span>
            <!--<span class="blockquote-footer2 pb-2">智慧司法</span>-->
            <span class="blockquote-footer2 pb-2" @click="navClick('7','8','125')">智慧食安</span>
          </el-col>
          <el-col :sapn="5" :lg="5">
            <h6>关于我们</h6>
            <span class="blockquote-footer2 pb-2" @click="navToClick('AboutUs')">企业简介</span>
            <span class="blockquote-footer2 pb-2">公司资质</span>
            <span class="blockquote-footer2 pb-2">招贤纳士</span>
          </el-col>
          <el-col :span="9" :lg="9">
            <div style="border-left: 1px solid #728197;" class="pl-4">
              <div class="ml-4">
                <h6>联系我们</h6>
                <div>
                  <img src="../assets/img/footer/24gf-telephone2.png" height="15">
                  <span class="quote-footer">0951-5177072</span>
                </div>
                <div>
                  <img src="../assets/img/footer/diqiu.png" height="15">
                  <span class="quote-footer">http://www.ccxb315.com/</span>
                </div>
                <div>
                  <img src="../assets/img/footer/youjian.png" height="15">
                  <span class="quote-footer">sjxt@dtiot.cn</span>
                </div>
                <div>
                  <img src="../assets/img/footer/loupanshuju.png" height="15">
                  <span class="quote-footer">宁夏回族自治区银川市金凤区宁安大街490号</span>
                </div>

                <div class="mt-4 d-flex">
                  <img src="../assets/img/footer/erweima.png" height="90">
                  <div class="pt-3 pl-3">
                    <span>扫码关注</span>
                    <span class="blockquote-footer2 pt-1">世纪信通服务号</span>
                  </div>
                </div>
              </div>
            </div>
          </el-col>

        </el-row>

      </div>
    </div>
    <div class="bg-gray-601 gray-301 p-2">
      <div class="container text-center mineSize">
    <span>版权所有&nbsp;&nbsp;
        宁夏世纪信通信息安全有限公司&nbsp;&nbsp;
        Copyright&nbsp;&nbsp;
        2019 All Rights Reserved. &nbsp;&nbsp;
        宁ICP备2020001882号-2</span>
      </div>
    </div>

  </div>
</template>

<script>
  import { getNewsDOList } from "@/api/index";
export default {
  name: 'abc',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      productList: [],
    }
  },
  methods: {
    navToClick(path){
      this.$router.push({
        path: path,
      })
    },
    navClick(id, type, cid) {
      this.$router.push({
        path: "product",
        query:{id: id, type: type, cid: cid}
        // query: {id: type, cid: cid}
      })
    },
    navNewsClick(row,pType){
      if(pType){
        this.$router.push({
          path:"product",
          query:{id: pType, type: row.type, cid: row.cid}
        })
      }else{
        this.$router.push({
          path:"product",
          query:{id: row.type, cid: row.cid}
        })
      }
    },
  },
  mounted() {
    getNewsDOList({limit:6,offset:0,type: 18}).then(response => {
      this.productList = response.rows;
    });
  }
}
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*@import url('../assets/css/footer.css');*/
/*@import url('../assets/css/bootstrap.css');*/
  .blockquote-footer2{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue